import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const ContractCreate = () => {
    const navigate = useNavigate();
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [previewHtml, setPreviewHtml] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const [formData, setFormData] = useState({
        user_id: '',
        type: 'service',
        contract_data: {
            responsible_expert_name: localStorage.getItem('username') || '',
            expert_info: {
                fio: '',
                position: '',       // ✅ қосылды
                iin: '',
                doc_num: '',
                address: '',
                bank_account: '',
                bank_name: '',
                phone: '',          // ✅ қосылды
                email: '',          // ✅ қосылды
            },
            items_table: [{
                title: '',
                grade: '',
                page_count: '',
                baspa_tabak: '',
                duration: '',       // ✅ қосылды (минут)
                unit_price: '',
                total_row: '',
            }],
            totals: {
                amount_numeric: '',
                amount_text_kz: '',
                amount_text_ru: '', // ✅ қосылды
            },
            dates: { start: '', end: '' }
        },
        workflow: [
            { user_id: '', role: 'executor', role_name: 'Регистратор (Номер қоюшы)' },
            { user_id: '', role: 'approver', role_name: 'Директор (Бекітуші)' }
        ]
    });

    const config = {
        headers: { 'Authorization': `Bearer ${localStorage.getItem("token")}` }
    };

    useEffect(() => {
        // ✅ phone, email, position қосылды
        axios.get('https://expertise.gov.kz/api/contracts/users', config)
            .then(res => setUsers(res.data))
            .catch(err => {});
    }, []);

    // ✅ Сарапшы таңдағанда барлық өрістерді толтыру
    const handleExpertSelect = (userId) => {
        const expert = users.find(u => u.id === parseInt(userId));
        if (expert) {
            setFormData(prev => ({
                ...prev,
                user_id: userId,
                contract_data: {
                    ...prev.contract_data,
                    expert_info: {
                        fio:          expert.name || '',
                        position:     expert.position || '',
                        iin:          expert.iin || '',
                        doc_num:      expert.document_number || '',
                        address:      expert.address || '',
                        bank_account: expert.iik || '',
                        bank_name:    expert.bank_name || '',
                        phone:        expert.phone || '',
                        email:        expert.email || '',
                    }
                }
            }));
        }
    };

    // ✅ Жол өзгергенде total_row автоматты есептеу
    const handleItemChange = (index, field, value) => {
        const items = [...formData.contract_data.items_table];
        items[index] = { ...items[index], [field]: value };

        // unit_price немесе baspa_tabak өзгерсе — total_row есепте
        const price     = parseFloat(field === 'unit_price'   ? value : items[index].unit_price)   || 0;
        const tabak     = parseFloat(field === 'baspa_tabak'  ? value : items[index].baspa_tabak)  || 0;
        items[index].total_row = (price * tabak).toFixed(2);

        setFormData(prev => ({
            ...prev,
            contract_data: { ...prev.contract_data, items_table: items }
        }));
    };

    // ✅ total_sheets және total_minutes автоматты есептеу
    const getTotalSheets  = () => formData.contract_data.items_table.reduce((s, i) => s + (parseFloat(i.baspa_tabak) || 0), 0);
    const getTotalMinutes = () => formData.contract_data.items_table.reduce((s, i) => s + (parseFloat(i.duration)    || 0), 0);
    const getTotalAmount  = () => formData.contract_data.items_table.reduce((s, i) => s + (parseFloat(i.total_row)   || 0), 0);

    const addRow = () => {
        const newItems = [...formData.contract_data.items_table, {
            title: '', grade: '', page_count: '', baspa_tabak: '', duration: '', unit_price: '', total_row: ''
        }];
        setFormData(prev => ({ ...prev, contract_data: { ...prev.contract_data, items_table: newItems } }));
    };

    const removeRow = (index) => {
        const items = formData.contract_data.items_table.filter((_, i) => i !== index);
        setFormData(prev => ({ ...prev, contract_data: { ...prev.contract_data, items_table: items } }));
    };

    const addSigner = () => {
        const newWorkflow = [...formData.workflow];
        newWorkflow.splice(newWorkflow.length - 1, 0, { user_id: '', role: 'signer', role_name: 'Келісуші' });
        setFormData(prev => ({ ...prev, workflow: newWorkflow }));
    };

    const handleWorkflowChange = (index, userId) => {
        const newWorkflow = [...formData.workflow];
        newWorkflow[index].user_id = userId;
        setFormData(prev => ({ ...prev, workflow: newWorkflow }));
    };

    // ✅ Preview жіберер алдында total_sheets, total_minutes қосамыз
    const buildPayload = () => ({
        ...formData,
        contract_data: {
            ...formData.contract_data,
            total_sheets:  getTotalSheets(),
            total_minutes: getTotalMinutes(),
        }
    });

    const handlePreview = async () => {
        try {
            const res = await axios.post(
                'https://expertise.gov.kz/api/contracts/preview',
                buildPayload(),
                config
            );
            setPreviewHtml(res.data.html);
            setShowModal(true);
        } catch (err) {
            alert("Предпросмотр қатесі! Барлық өрістерді толтырғаныңызды тексеріңіз.");
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const res = await axios.post(
                'https://expertise.gov.kz/api/contracts',
                { type: formData.type },
                config
            );
            const contractId = res.data.contract_id;

            await axios.post(
                `https://expertise.gov.kz/api/contracts/${contractId}/update-content`,
                buildPayload(),
                config
            );

            alert("Келісімшарт сақталды және жіберілді!");
           navigate(`/contracts/${contractId}`);
        } catch (err) {

            alert("Сақтау қатесі: " + (err.response?.data?.message || err.message));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.card}>
                <h2 style={styles.title}>📝 Жаңа келісімшарт құру</h2>

                <form onSubmit={handleSubmit}>

                    {/* ========== 1. САРАПШЫ ========== */}
                    <div style={styles.section}>
                        <h4 style={styles.sectionTitle}>👤 1. Сарапшы мәліметтері</h4>
                        <div style={styles.grid}>
                            <div style={styles.formGroup}>
                                <label style={styles.label}>Сарапшыны таңдаңыз: *</label>
                                <select style={styles.input} onChange={(e) => handleExpertSelect(e.target.value)} required>
                                    <option value="">--- Таңдау ---</option>
                                    {users.map(u => <option key={u.id} value={u.id}>{u.name}</option>)}
                                </select>
                            </div>
                            <div style={styles.formGroup}>
                                <label style={styles.label}>Лауазымы (Должность):</label>
                                <input style={styles.input} value={formData.contract_data.expert_info.position} readOnly placeholder="автоматты" />
                            </div>
                            <div style={styles.formGroup}>
                                <label style={styles.label}>ИИН:</label>
                                <input style={styles.input} value={formData.contract_data.expert_info.iin} readOnly />
                            </div>
                            <div style={styles.formGroup}>
                                <label style={styles.label}>Жеке куәлік №:</label>
                                <input style={styles.input} value={formData.contract_data.expert_info.doc_num} readOnly />
                            </div>
                            <div style={styles.formGroup}>
                                <label style={styles.label}>Есепшот (IIK):</label>
                                <input style={styles.input} value={formData.contract_data.expert_info.bank_account} readOnly />
                            </div>
                            <div style={styles.formGroup}>
                                <label style={styles.label}>Банк:</label>
                                <input style={styles.input} value={formData.contract_data.expert_info.bank_name} readOnly />
                            </div>
                            <div style={styles.formGroup}>
                                <label style={styles.label}>Мекенжайы:</label>
                                <input style={styles.input} value={formData.contract_data.expert_info.address} readOnly />
                            </div>
                            {/* ✅ phone және email — users-та болса автоматты, болмаса қолмен */}
                            <div style={styles.formGroup}>
                                <label style={styles.label}>Телефон:</label>
                                <input
                                    style={styles.input}
                                    value={formData.contract_data.expert_info.phone}
                                    onChange={(e) => setFormData(prev => ({
                                        ...prev,
                                        contract_data: {
                                            ...prev.contract_data,
                                            expert_info: { ...prev.contract_data.expert_info, phone: e.target.value }
                                        }
                                    }))}
                                    placeholder="+7 777 000 00 00"
                                />
                            </div>
                            <div style={styles.formGroup}>
                                <label style={styles.label}>E-mail:</label>
                                <input
                                    style={styles.input}
                                    value={formData.contract_data.expert_info.email}
                                    onChange={(e) => setFormData(prev => ({
                                        ...prev,
                                        contract_data: {
                                            ...prev.contract_data,
                                            expert_info: { ...prev.contract_data.expert_info, email: e.target.value }
                                        }
                                    }))}
                                    placeholder="email@example.com"
                                />
                            </div>
                        </div>
                    </div>

                    {/* ========== 2. ЖҰМЫС КЕСТЕСІ ========== */}
                    <div style={styles.section}>
                        <h4 style={styles.sectionTitle}>📚 2. Жұмыс көлемі</h4>
                        <div style={{overflowX: 'auto'}}>
                            <table style={styles.table}>
                                <thead>
                                    <tr style={{backgroundColor: '#f0f5ff'}}>
                                        <th style={styles.th}>№</th>
                                        <th style={styles.th}>Атауы</th>
                                        <th style={styles.th}>Сынып</th>
                                        <th style={styles.th}>Бет саны</th>
                                        <th style={styles.th}>Баспа табақ</th>
                                        <th style={styles.th}>Минут ⏱</th>
                                        <th style={styles.th}>Бағасы (бірлік)</th>
                                        <th style={styles.th}>Жиыны</th>
                                        <th style={styles.th}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {formData.contract_data.items_table.map((item, index) => (
                                        <tr key={index}>
                                            <td style={styles.td}>{index + 1}</td>
                                            <td style={styles.td}>
                                                <input style={styles.tableInput} value={item.title}
                                                    onChange={(e) => handleItemChange(index, 'title', e.target.value)} />
                                            </td>
                                            <td style={styles.td}>
                                                <input style={{...styles.tableInput, width: '60px'}} value={item.grade}
                                                    onChange={(e) => handleItemChange(index, 'grade', e.target.value)} />
                                            </td>
                                            <td style={styles.td}>
                                                <input type="number" style={{...styles.tableInput, width: '70px'}} value={item.page_count}
                                                    onChange={(e) => handleItemChange(index, 'page_count', e.target.value)} />
                                            </td>
                                            <td style={styles.td}>
                                                <input type="number" style={{...styles.tableInput, width: '80px'}} value={item.baspa_tabak}
                                                    onChange={(e) => handleItemChange(index, 'baspa_tabak', e.target.value)} />
                                            </td>
                                            {/* ✅ Минут өрісі */}
                                            <td style={styles.td}>
                                                <input type="number" style={{...styles.tableInput, width: '70px'}} value={item.duration}
                                                    onChange={(e) => handleItemChange(index, 'duration', e.target.value)} />
                                            </td>
                                            <td style={styles.td}>
                                                <input type="number" style={{...styles.tableInput, width: '90px'}} value={item.unit_price}
                                                    onChange={(e) => handleItemChange(index, 'unit_price', e.target.value)} />
                                            </td>
                                            {/* ✅ Автоматты есептелген жиыны */}
                                            <td style={{...styles.td, fontWeight: 'bold', color: '#2b5da7'}}>
                                                {item.total_row || '0.00'} ₸
                                            </td>
                                            <td style={styles.td}>
                                                {formData.contract_data.items_table.length > 1 && (
                                                    <button type="button" onClick={() => removeRow(index)} style={styles.btnRemove}>✕</button>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                                {/* ✅ Жиынтық жол */}
                                <tfoot>
                                    <tr style={{backgroundColor: '#f6ffed', fontWeight: 'bold'}}>
                                        <td colSpan={4} style={{...styles.td, textAlign: 'right'}}>Барлығы:</td>
                                        <td style={styles.td}>{getTotalSheets().toFixed(2)} б.т.</td>
                                        <td style={styles.td}>{getTotalMinutes()} мин.</td>
                                        <td style={styles.td}></td>
                                        <td style={{...styles.td, color: '#389e0d'}}>{getTotalAmount().toFixed(2)} ₸</td>
                                        <td style={styles.td}></td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                        <button type="button" onClick={addRow} style={styles.btnAdd}>+ Жол қосу</button>
                    </div>

                    {/* ========== 3. МЕРЗІМ ЖӘНЕ СОМА ========== */}
                    <div style={styles.section}>
                        <h4 style={styles.sectionTitle}>💰 3. Мерзімі және Төлем</h4>
                        <div style={styles.grid}>
                            <div style={styles.formGroup}>
                                <label style={styles.label}>Басталу күні: *</label>
                                <input type="date" style={styles.input} value={formData.contract_data.dates.start}
                                    onChange={(e) => setFormData(prev => ({
                                        ...prev,
                                        contract_data: { ...prev.contract_data, dates: { ...prev.contract_data.dates, start: e.target.value } }
                                    }))} required />
                            </div>
                            <div style={styles.formGroup}>
                                <label style={styles.label}>Аяқталу күні: *</label>
                                <input type="date" style={styles.input} value={formData.contract_data.dates.end}
                                    onChange={(e) => setFormData(prev => ({
                                        ...prev,
                                        contract_data: { ...prev.contract_data, dates: { ...prev.contract_data.dates, end: e.target.value } }
                                    }))} required />
                            </div>
                            <div style={styles.formGroup}>
                                <label style={styles.label}>Жалпы сома (санмен): *</label>
                                <input type="number" style={styles.input} value={formData.contract_data.totals.amount_numeric}
                                    onChange={(e) => setFormData(prev => ({
                                        ...prev,
                                        contract_data: { ...prev.contract_data, totals: { ...prev.contract_data.totals, amount_numeric: e.target.value } }
                                    }))} required />
            
                            </div>
                            {/* ✅ Қазақша сома */}
                            <div style={styles.formGroup}>
                                <label style={styles.label}>Сома (қазақша сөзбен): *</label>
                                <input style={styles.input} value={formData.contract_data.totals.amount_text_kz}
                                    placeholder="мысалы: жүз мың теңге"
                                    onChange={(e) => setFormData(prev => ({
                                        ...prev,
                                        contract_data: { ...prev.contract_data, totals: { ...prev.contract_data.totals, amount_text_kz: e.target.value } }
                                    }))} required />
                            </div>
                            {/* ✅ Орысша сома — жаңа өріс */}
                            <div style={styles.formGroup}>
                                <label style={styles.label}>Сома (орысша сөзбен): *</label>
                                <input style={styles.input} value={formData.contract_data.totals.amount_text_ru}
                                    placeholder="например: сто тысяч тенге"
                                    onChange={(e) => setFormData(prev => ({
                                        ...prev,
                                        contract_data: { ...prev.contract_data, totals: { ...prev.contract_data.totals, amount_text_ru: e.target.value } }
                                    }))} required />
                            </div>
                        </div>
                    </div>

                    {/* ========== 4. WORKFLOW ========== */}
                    <div style={styles.section}>
                        <h4 style={styles.sectionTitle}>👥 4. Қол қоюшыларды таңдау</h4>
                        {formData.workflow.map((step, index) => (
                            <div key={index} style={styles.workflowRow}>
                                <span style={styles.workflowLabel}>{step.role_name}:</span>
                                <select style={{...styles.input, maxWidth: '400px'}}
                                    onChange={(e) => handleWorkflowChange(index, e.target.value)} required>
                                    <option value="">--- Таңдаңыз ---</option>
                                    {users.map(u => (
                                        <option key={u.id} value={u.id}>{u.name} — {u.position}</option>
                                    ))}
                                </select>
                            </div>
                        ))}
                        <button type="button" onClick={addSigner} style={styles.btnSecondary}>+ Келісуші қосу</button>
                    </div>

                    <div style={styles.footer}>
                        <button type="button" onClick={handlePreview} style={styles.btnPreview}>👁 Предпросмотр</button>
                        <button type="submit" disabled={loading} style={styles.btnSubmit}>
                            {loading ? 'Сақталуда...' : '💾 Сақтау және Жіберу'}
                        </button>
                    </div>
                </form>
            </div>

            {/* ========== ПРЕДПРОСМОТР МОДАЛЫ ========== */}
            {showModal && (
                <div style={styles.modalOverlay}>
                    <div style={styles.modalContent}>
                        <div style={styles.modalHeader}>
                            <h3 style={{margin: 0}}>Келісімшарттың алдын ала нұсқасы</h3>
                            <button onClick={() => setShowModal(false)} style={styles.btnClose}>✕ Жабу</button>
                        </div>
                        <div style={styles.modalBody} dangerouslySetInnerHTML={{ __html: previewHtml }} />
                    </div>
                </div>
            )}
        </div>
    );
};

const styles = {
    container:     { padding: '20px', backgroundColor: '#f0f2f5', minHeight: '100vh' },
    card:          { backgroundColor: '#fff', padding: '30px', borderRadius: '8px', maxWidth: '1200px', margin: '0 auto', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' },
    title:         { color: '#2b5da7', borderBottom: '2px solid #2b5da7', paddingBottom: '10px', marginBottom: '20px' },
    section:       { marginBottom: '25px', padding: '20px', border: '1px solid #e8e8e8', borderRadius: '8px', backgroundColor: '#fafafa' },
    sectionTitle:  { margin: '0 0 15px', color: '#333' },
    grid:          { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '15px' },
    formGroup:     { display: 'flex', flexDirection: 'column' },
    label:         { fontSize: '13px', marginBottom: '5px', color: '#555' },
    input:         { padding: '8px', borderRadius: '4px', border: '1px solid #d9d9d9', width: '100%', boxSizing: 'border-box' },
    table:         { width: '100%', borderCollapse: 'collapse', marginTop: '10px', fontSize: '13px' },
    th:            { border: '1px solid #d9d9d9', padding: '8px 6px', textAlign: 'center', fontWeight: '600', fontSize: '12px' },
    td:            { border: '1px solid #d9d9d9', padding: '6px', textAlign: 'center' },
    tableInput:    { width: '100%', padding: '5px', border: '1px solid #ddd', borderRadius: '3px', boxSizing: 'border-box' },
    btnAdd:        { marginTop: '10px', backgroundColor: '#52c41a', color: '#fff', border: 'none', padding: '8px 15px', borderRadius: '4px', cursor: 'pointer' },
    btnRemove:     { backgroundColor: '#ff4d4f', color: '#fff', border: 'none', padding: '3px 8px', borderRadius: '3px', cursor: 'pointer' },
    btnSecondary:  { backgroundColor: '#faad14', color: '#fff', border: 'none', padding: '6px 12px', borderRadius: '4px', cursor: 'pointer' },
    workflowRow:   { display: 'flex', alignItems: 'center', marginBottom: '10px', gap: '10px' },
    workflowLabel: { minWidth: '200px', fontSize: '14px', color: '#444' },
    footer:        { display: 'flex', justifyContent: 'flex-end', gap: '15px', marginTop: '30px' },
    btnSubmit:     { backgroundColor: '#2b5da7', color: '#fff', padding: '10px 30px', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' },
    btnPreview:    { backgroundColor: '#1890ff', color: '#fff', padding: '10px 30px', border: 'none', borderRadius: '4px', cursor: 'pointer' },
    modalOverlay:  { position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.7)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 },
    modalContent:  { backgroundColor: '#fff', width: '85%', height: '90%', borderRadius: '8px', overflow: 'hidden', display: 'flex', flexDirection: 'column' },
    modalHeader:   { padding: '15px 20px', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
    modalBody:     { flex: 1, padding: '40px', overflowY: 'auto' },
    btnClose:      { backgroundColor: '#ff4d4f', color: '#fff', border: 'none', padding: '5px 15px', borderRadius: '4px', cursor: 'pointer' }
};

export default ContractCreate;